// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__N5lwr","mainContent":"DashboardLayout_mainContent__l-g8B","contentWrapper":"DashboardLayout_contentWrapper__sksOm"};